import { defineFcm } from '../shared/factory';

export const FCM_IDENTIFIED_SAVED_PAYMENT_METHOD_ENFORCEMENT = defineFcm('identified_saved_payment_method_enforcement')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-koi',
		scope: ['corgi-middle-end', 'payment-service'],
		supportedGroups: { global: true },
		context: 'Payment method vaulting and saved-method charges',
		description:
			'When on, the middle-end and payment-service reject identified (email-link) sessions that save a payment method to their account, or that set up or charge a saved one without a token; when off they are allowed, as before the identified-session checks existed. Tokenless setup and charges by guests are refused either way. Turn it on only while revenue_membership_identified_login_gate is enabled and serves variant_1 to every identified session: in control, and whenever that experiment is off, the front-end lets identified sessions submit, and with enforcement on they would fail server-side with the generic payment error.',
	});
